import { Environment } from '.';

/**
 * Attempts to determine the auth environment using the application's
 * environment.
 * 
 * @returns { string }
 */
export function getAuthEnv( appEnv ) {
    if ( appEnv === Environment.LOCAL || appEnv === Environment.DEV || appEnv === Environment.UNKNOWN ) {
        return Environment.QA;
    } else {
        return appEnv;
    }
}
